import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";

export const emptyCoreNetworkWorkRequestForm = {
  title: "",
  requestType: "artwork-proof",
  fulfillmentProvider: "core-network",
  networkType: "design",
  sourceModule: "proofing",
  description: "",
  instructions: "",
  deadlineAt: "",
  budgetAmount: "",
  budgetCurrency: "CAD",
  documentType: "",
  documentId: "",
  orderId: "",
  poId: "",
  productionJobId: "",
};

export default function CoreNetworkWorkRequestForm({
  open,
  onClose,
  onSubmit,
  submitting = false,
  canManagePayment = false,
}) {
  const [form, setForm] = useState(emptyCoreNetworkWorkRequestForm);

  useEffect(() => {
    if (open) setForm(emptyCoreNetworkWorkRequestForm);
  }, [open]);

  const setField = (field) => (event) => {
    setForm((current) => ({ ...current, [field]: event.target.value }));
  };

  const handleSubmit = () => onSubmit?.({
    ...form,
    budgetAmount: form.budgetAmount ? Number(form.budgetAmount) : null,
    poId: form.poId ? Number(form.poId) : null,
    productionJobId: form.productionJobId ? Number(form.productionJobId) : null,
  });

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth="md">
      <DialogTitle>Create work request</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} sx={{ mt: 0.25 }}>
          <Grid item xs={12} md={6}>
            <TextField fullWidth autoFocus label="Title" value={form.title} onChange={setField("title")} />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField fullWidth label="Request type" value={form.requestType} onChange={setField("requestType")} />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField fullWidth select label="Provider" value={form.fulfillmentProvider} onChange={setField("fulfillmentProvider")}>
              {["core-network", "internal", "binated"].map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField fullWidth label="Network type" value={form.networkType} onChange={setField("networkType")} />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField fullWidth label="Source module" value={form.sourceModule} onChange={setField("sourceModule")} />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField fullWidth type="datetime-local" label="Deadline" InputLabelProps={{ shrink: true }} value={form.deadlineAt} onChange={setField("deadlineAt")} />
          </Grid>
          {canManagePayment ? (
            <Grid item xs={12} md={4}>
              <TextField fullWidth type="number" label="Budget amount" value={form.budgetAmount} onChange={setField("budgetAmount")} inputProps={{ min: 0 }} />
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <TextField fullWidth multiline minRows={2} label="Description" value={form.description} onChange={setField("description")} />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth multiline minRows={3} label="Instructions" value={form.instructions} onChange={setField("instructions")} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField fullWidth label="Order ID" value={form.orderId} onChange={setField("orderId")} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField fullWidth label="PO ID" value={form.poId} onChange={setField("poId")} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField fullWidth label="Production Job ID" value={form.productionJobId} onChange={setField("productionJobId")} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField fullWidth label="Document type" value={form.documentType} onChange={setField("documentType")} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField fullWidth label="Document ID" value={form.documentId} onChange={setField("documentId")} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={submitting || !form.requestType.trim()}>
          {submitting ? "Creating..." : "Create work request"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
